import { Card } from "react-bootstrap";
import LoginHeader from "app/containers/Login/LoginHeader";

interface Props {
  title: string;
  message: string;
}

export default function McpMessageCard({ title, message }: Props) {
  return (
    <div className="login-page">
      <Card>
        <LoginHeader title={title} />
        <p>{message}</p>
      </Card>
    </div>
  );
}
